/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Value to compare against — string, number, or array depending on operator
 */
export type FilterItemDtoValue = string | number | boolean | unknown[];
